import PropTypes from 'prop-types';

import KeywordTable from '../keywords/keywordtable';

const SearchResultsBody = ({ major, minor, results }) => {
  return (
    <div className="mt-4">
      <h3 aria-live="polite" className="text-center sm:col-span-2">
        {major}
      </h3>
      {minor && <p className="text-center sm:col-span-2">{minor}</p>}
      <KeywordTable commands={results} />
    </div>
  );
};

SearchResultsBody.propTypes = {
  major: PropTypes.string.isRequired,
  minor: PropTypes.string,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      keyword: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SearchResultsBody;
